import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

interface Props {
  empty: boolean
}
interface PropsAuth {
  isAuth: boolean
}
export const TrackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 167px;
  width: 100%;

  @media ${device.smallScreen} {
    width: 303px;
    // padding-top: 96px;
    padding-top: ${(props: PropsAuth) => (props.isAuth ? '96px' : '0px')};
  }
`

export const TrackWrapperInner = styled.div`
  width: 100%;
  background-color: ${colors.white};
  padding: 24px;
  border-radius: 4px;
  margin-bottom: 15px;
`

export const WrapperForSubHeaderSide = styled.div<Props>`
  margin-bottom: ${(props: Props) => (props.empty ? '24px' : '17px')};
`

export const List = styled.ul`
  padding: 0px;
  margin-bottom: 8px;
`

export const BtnReviewContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  margin-right: -40px;
  margin-left: -16px;
  height: 72px;
  width: 100%;
  position: fixed;
  bottom: 0;
  filter: drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.25));
`
